"use client";

import classes from "./CountdownComponent.module.css";
import Countdown from "react-countdown";

const CountdownComponent = (props) => {
  const { endDate } = props;

  const renderer = ({ formatted: { hours, minutes, seconds }, completed }) => {
    if (completed) {
      // Render a completed state
      return;
    } else if (hours < 48) {
      // Render a countdown
      return (
        <span className={classes.expirationTime}>
          Sale ends in {hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  return (
    <>
      <Countdown date={endDate} renderer={renderer} daysInHours />
    </>
  );
};

export default CountdownComponent;
